import React from "react";

import Vik from "../assets/vik.jpg";

import { SiteWrapper } from "../components";
import { Image } from "../layouts";

const key = `
-----BEGIN PGP PUBLIC KEY BLOCK-----
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=vC8u
-----END PGP PUBLIC KEY BLOCK-----`;

const IndexPage = () => (
  <SiteWrapper>
    <h1>Hi people</h1>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Image
        src={Vik}
        style={{ width: "20%", borderRadius: "50%" }}
        alt="A picture of me!"
        key="vikram-headshot-1"
      />
    </div>
    <br />
    <p>
      My name is Vikram Venkataramanan. I am a software developer based in
      Toronto. After finishing up my CompSci degree, I dabbled around a bit
      writing low-level code for high-performance software defined radios.
      Nowadays, I spend my time constructing and maintaining ecobee’s
      subscription platform.
    </p>
    <h2>My PGP Key</h2>
    <pre>{key}</pre>
  </SiteWrapper>
);

export default IndexPage;
